import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Eye } from "react-feather";

const emailLogsTableColumn = [
    {
        Header: "S.no",
        id: "s_no",
        width: "75",
    },
    {
        Header: "Actions",
        width:"100",
        Cell: ({ row }) => {
            return (
                <>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>View Email</Tooltip>}
                    >
                        <a
                            href={`/tms/notifications/email-logs/${row.original.id}`}
                            target="_blank"
                            rel="noreferrer"
                            className="me-1"
                        >
                            <span>
                                <Eye size="18" color="#6c757d" />
                            </span>
                        </a>
                    </OverlayTrigger>
                </>
            );
        },
    },
    {
        Header: "Module",
        accessor: "module",
    },
    {
        Header: "Subject",
        accessor: "subject",
        width:"300"
    },
    {
        Header: "Sent to name",
        accessor: "sent_to_name",
        width: "200",
    },
    {
        Header: "Sent to email",
        accessor: "sent_to_email",
        width: "300",
    },
    {
        Header: "From email",
        accessor: "from_email",
        width: "300",
    },
    {
        Header: "CC email",
        accessor: "cc_email",
    },
    {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => {
            const isSuccess = value === 1;

            return (
                <Badge bg={isSuccess ? "success" : "danger"}>
                    {isSuccess ? "Success" : "Failed"}
                </Badge>
            );
        },
    },
    {
        Header: "Sent At",
        accessor: "created_at",
    },
];

export { emailLogsTableColumn };
